export const msalConfig = {
  auth: {
    clientId: process.env.REACT_APP_CLIENTID,
    authority: `https://login.microsoftonline.com/${process.env.REACT_APP_AUTHORITY}`,
    redirectUri: process.env.REACT_APP_REDIRECTURI,
    postLogoutRedirectUri: process.env.REACT_APP_POSTLOGOUTREDIRECTURI,
  },
  cache: {
    cacheLocation: "localStorage",
    storeAuthStateInCookie: true,
  },
  system: {
    tokenRenewalOffsetSeconds: 300,
  },
};

export const loginRequest = {
  scopes: ["User.Read", "User.ReadBasic.All", "profile", "Presence.Read.All"],
  forceRefresh: true,
};

export const graphConfig = {
  graphMeEndpoint: `${process.env.REACT_APP_GRAPHENDPOINT}/me`,
};

export const apiRequest = {
  scopes: [`api://${process.env.REACT_APP_CLIENTID}/api`],
};

export const thinkApiRequest = {
  scopes: [`api://${process.env.REACT_APP_THINK_CLIENTID}/api`],
};
